// extracted by mini-css-extract-plugin
var _1 = "qthV3";
var _2 = "NJO3m";
export { _1 as "base", _2 as "toggle" }
